import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const MapMarkerGlyph = /*#__PURE__*/createElement("svg", {
  id: "mapMarker",
  transform: "scale(3.6, 3.6)"
}, /*#__PURE__*/createElement("circle", {
  opacity: "0.2",
  cx: "42",
  cy: "42",
  r: "42"
}), /*#__PURE__*/createElement("circle", {
  cx: "42",
  cy: "42",
  r: "35",
  fill: "white",
  stroke: "transparent"
}), /*#__PURE__*/createElement("circle", {
  cx: "42",
  cy: "42",
  r: "25"
}));
const MapMarker = createSvg({
  name: 'mapMarker',
  path: MapMarkerGlyph
});

export default MapMarker;
export { MapMarkerGlyph };
